// extracted by mini-css-extract-plugin
export default {"container":"user-layout_container__pPHMQ","showSearch":"user-layout_showSearch__UMVA9"};